module.exports = __webpack_public_path__ + "static/media/yesterdayBGmobile.ecdb9d13.png";